'use client';

import { useLayoutEffect } from 'react';

export default function ThemeHydrationSync() {
  useLayoutEffect(() => {
    const theme = window.__theme;

    if (theme !== 'light' && theme !== 'dark') {
      return;
    }

    if (document.documentElement.dataset.theme === theme) {
      return;
    }

    // React can remove or overwrite html[data-theme] while hydrating root layouts.
    document.documentElement.dataset.theme = theme;
  }, []);

  return null;
}
